<template>
  <div class="page">
    <div class="contract-head">
      <div>
        <span>FORMAL CONTRACT</span>
        <h1>正式电子签约协议</h1>
        <p>套餐已支付，本协议签署完成后将正式绑定机具。</p>
      </div>
      <div class="version">{{ agreement.version }}</div>
    </div>
    <div class="card party">
      <div>
        <span>签约人</span><b>{{ agreement.customer_name }}</b>
      </div>
      <div>
        <span>机具编号</span><b>{{ agreement.machine_code }}</b>
      </div>
      <div>
        <span>设备SN</span><b>{{ agreement.device_sn }}</b>
      </div>
      <div>
        <span>联系电话</span><b>{{ agreement.customer_phone }}</b>
      </div>
    </div>
    <div class="card agreement" @scroll="onScroll" ref="box">
      <h2>{{ agreement.title }}</h2>
      <div class="contract-content">{{ agreement.content }}</div>
      <div class="seal-area" v-if="agreement.company_seal_url">
        <span>乙方盖章</span
        ><img :src="agreement.company_seal_url" alt="乙方公章" />
      </div>
      <div class="contract-end">— 协议正文已到底 —</div>
    </div>
    <div class="card sign-panel">
      <div class="warn">
        必须阅读满10秒、滚动到协议底部并完成手写电子签名，签约后自动完成机具绑定。
      </div>
      <div class="progress-row">
        <div>
          <span>阅读时间</span><b>{{ Math.min(seconds, 10) }}/10 秒</b>
        </div>
        <div>
          <span>滚动进度</span><b>{{ progress }}%</b>
        </div>
      </div>
      <div class="signature-pad" :class="{ fullscreen: signatureFullscreen }" v-if="canSign">
        <div class="signature-head">
          <b>甲方电子签名</b>
          <div><button v-if="!signatureFullscreen" type="button" @click="openFullSignature">全屏签名</button><button type="button" @click="clearSignature">清除重签</button></div>
        </div>
        <canvas
          ref="signature"
          @mousedown="startDraw"
          @mousemove="draw"
          @mouseup="endDraw"
          @mouseleave="endDraw"
          @touchstart.prevent="startDraw"
          @touchmove.prevent="draw"
          @touchend.prevent="endDraw"
        ></canvas>
        <button v-if="!signatureFullscreen" class="signature-expand" type="button" @click="openFullSignature">点击放大全屏签名</button>
        <div class="signature-status">
          {{
            signatureDone
              ? "签名已完成，将写入正式协议PDF"
              : "请使用手指或鼠标签写姓名"
          }}
        </div>
        <div class="fullscreen-actions" v-if="signatureFullscreen"><button type="button" @click="closeFullSignature">取消</button><button class="done" type="button" @click="finishFullSignature">完成签名</button></div>
      </div>
      <div class="signature-locked" v-else>
        阅读时间和滚动进度全部达标后，将开启电子签名区域。
      </div>
      <label class="check"
        ><input
          type="checkbox"
          v-model="checked"
          :disabled="!canSign || !signatureDone"
        /><span
          >本人已完整阅读、完成电子签名并同意以上正式电子协议内容</span
        ></label
      ><button
        class="btn sign-btn"
        :disabled="!checked || !signatureDone || submitting"
        @click="sign"
      >
        {{ submitting ? "正在签约…" : "确认签约并完成绑定" }}
      </button>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
export default {
  data: () => ({
    agreement: {},
    seconds: 0,
    progress: 0,
    checked: false,
    submitting: false,
    drawing: false,
    signatureDone: false,
    signatureFullscreen: false,
    last: null,
  }),
  computed: {
    canSign() {
      return this.seconds >= 10 && this.progress >= 100;
    },
  },
  watch: {
    canSign(v) {
      if (v) this.$nextTick(this.initCanvas);
    },
  },
  async created() {
    const applicationId = this.$route.query.applicationId;
    if (!applicationId) {
      alert("请先选择套餐并完成支付");
      this.$router.replace("/bind-device");
      return;
    }
    try {
      this.agreement = (
        await api.get("/h5/agreement", { params: { applicationId } })
      ).data.data;
    } catch (e) {
      localStorage.removeItem("pendingApplicationId");
      localStorage.removeItem("pendingOrderNo");
      localStorage.removeItem("pendingDeviceSn");
      alert(
        (e.response && e.response.data && e.response.data.message) ||
          "协议加载失败"
      );
      this.$router.replace("/bind-device");
      return;
    }
    this.$nextTick(() => {
      const e = this.$refs.box;
      if (e && e.scrollHeight <= e.clientHeight) this.progress = 100;
    });
    this.timer = setInterval(() => this.seconds++, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    document.body.style.overflow = "";
  },
  methods: {
    openFullSignature() {
      const old = this.$refs.signature && this.signatureDone ? this.$refs.signature.toDataURL("image/png") : "";
      this.signatureFullscreen = true;
      document.body.style.overflow = "hidden";
      this.$nextTick(() => this.initCanvas(old));
    },
    closeFullSignature() { this.signatureFullscreen = false; document.body.style.overflow = ""; },
    finishFullSignature() { if (!this.signatureDone) return alert("请先签写姓名"); this.closeFullSignature(); },
    onScroll() {
      const e = this.$refs.box;
      this.progress = Math.min(
        100,
        Math.round(((e.scrollTop + e.clientHeight) / e.scrollHeight) * 100)
      );
    },
    initCanvas(savedImage) {
      const c = this.$refs.signature;
      if (!c) return;
      const ratio = window.devicePixelRatio || 1;
      c.width = Math.max(600, Math.round(c.clientWidth * ratio));
      c.height = Math.round((this.signatureFullscreen ? c.clientHeight : 170) * ratio);
      const ctx = c.getContext("2d");
      ctx.scale(ratio, ratio);
      ctx.lineWidth = 3;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#152d25";
      if (savedImage) { const image = new Image(); image.onload = () => ctx.drawImage(image, 0, 0, c.clientWidth, c.clientHeight); image.src = savedImage; }
    },
    point(e) {
      const r = this.$refs.signature.getBoundingClientRect(),
        t = e.touches && e.touches[0] ? e.touches[0] : e;
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    },
    startDraw(e) {
      this.drawing = true;
      this.last = this.point(e);
    },
    draw(e) {
      if (!this.drawing) return;
      const p = this.point(e),
        ctx = this.$refs.signature.getContext("2d");
      ctx.beginPath();
      ctx.moveTo(this.last.x, this.last.y);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      this.last = p;
      this.signatureDone = true;
    },
    endDraw() {
      this.drawing = false;
      this.last = null;
    },
    clearSignature() {
      const c = this.$refs.signature;
      if (c) c.getContext("2d").clearRect(0, 0, c.width, c.height);
      this.signatureDone = false;
      this.checked = false;
    },
    async sign() {
      if (!this.signatureDone) {
        alert("请先完成甲方电子签名");
        return;
      }
      this.submitting = true;
      try {
        await api.post("/h5/agreement/sign", {
          applicationId: this.agreement.application_id,
          scrollProgress: this.progress,
          staySeconds: this.seconds,
          agreed: this.checked,
          phoneModel: navigator.userAgent,
          signatureData: this.$refs.signature.toDataURL("image/png"),
        });
        localStorage.removeItem("pendingApplicationId");
        localStorage.removeItem("pendingOrderNo");
        alert("签约成功，机具绑定已完成");
        this.$router.replace("/");
      } catch (e) {
        alert(
          (e.response && e.response.data && e.response.data.message) ||
            "签约失败"
        );
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
<style scoped>
.contract-head {
  background: linear-gradient(135deg, #183451, #326ba3);
  color: #fff;
  border-radius: 26px;
  padding: 28px 32px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contract-head span {
  font-size: 12px;
  letter-spacing: 2px;
  opacity: 0.7;
}
.contract-head h1 {
  margin: 7px 0;
}
.contract-head p {
  margin: 0;
  opacity: 0.8;
}
.version {
  background: rgba(255, 255, 255, 0.16);
  padding: 9px 15px;
  border-radius: 99px;
}
.party {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
.party div {
  background: #f4f8fc;
  border-radius: 14px;
  padding: 12px;
}
.party span {
  display: block;
  color: #7b8895;
  font-size: 12px;
}
.party b {
  display: block;
  margin-top: 5px;
  word-break: break-all;
}
.agreement {
  height: 480px;
  overflow: auto;
  white-space: pre-wrap;
  padding: 28px;
}
.agreement h2 {
  text-align: center;
}
.contract-content {
  white-space: pre-wrap;
  line-height: 1.9;
  color: #263747;
}
.contract-end {
  text-align: center;
  color: #9aa7b1;
  padding: 36px 0 8px;
}
.progress-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 16px 0;
}
.progress-row div {
  background: #f3f7fb;
  border-radius: 14px;
  padding: 12px;
}
.progress-row span {
  color: #72808c;
  margin-right: 8px;
}
.check {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  padding: 14px;
  border: 1px solid #dce6ef;
  border-radius: 14px;
}
.sign-btn {
  width: 100%;
  margin-top: 14px;
}
.sign-btn:disabled {
  opacity: 0.45;
}
@media (max-width: 768px) {
  .contract-head {
    padding: 20px;
    display: block;
  }
  .version {
    display: inline-block;
    margin-top: 12px;
  }
  .party {
    grid-template-columns: 1fr 1fr;
  }
  .agreement {
    height: 420px;
    padding: 18px;
  }
  .progress-row {
    grid-template-columns: 1fr;
  }
}
.sign-panel .check {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 18px;
  background: #fbfdff;
  cursor: pointer;
}
.sign-panel .check input {
  display: block !important;
  flex: 0 0 18px !important;
  width: 18px !important;
  height: 18px !important;
  margin: 0 !important;
  padding: 0 !important;
}
.sign-panel .check span {
  display: block !important;
  flex: 1;
  text-align: left !important;
  line-height: 1.6;
  color: #263747;
}
@media (max-width: 768px) {
  .sign-panel .check {
    padding: 14px;
    align-items: flex-start !important;
  }
}
.agreement {
  position: relative;
}
.seal-area {
  min-height: 190px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 48px 0;
}
.seal-area span {
  color: #81908a;
  font-size: 13px;
  margin-right: 12px;
}
.seal-area img {
  display: block;
  width: 170px;
  height: 170px;
  object-fit: contain;
  mix-blend-mode: multiply;
  opacity: 0.9;
}
@media (max-width: 768px) {
  .seal-area {
    min-height: 150px;
    padding: 8px 10px 0;
  }
  .seal-area img {
    width: 135px;
    height: 135px;
  }
}
</style>

<style scoped>
.signature-pad {
  margin: 16px 0;
  border: 1px solid #cbdceb;
  border-radius: 16px;
  padding: 14px;
  background: #f8fbfe;
}
.signature-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.signature-head button {
  border: 0;
  background: #e8f1f9;
  color: #245d91;
  border-radius: 99px;
  padding: 8px 13px;
  cursor: pointer;
}
.signature-pad canvas {
  display: block;
  width: 100%;
  height: 170px;
  background: #fff;
  border: 1px dashed #9cbad4;
  border-radius: 12px;
  touch-action: none;
}
.signature-status {
  text-align: center;
  color: #286a9e;
  font-size: 12px;
  margin-top: 8px;
}
.signature-locked {
  margin: 16px 0;
  padding: 14px;
  text-align: center;
  border-radius: 13px;
  background: #f3f6f9;
  color: #748391;
}
@media (max-width: 768px) {
  .signature-pad canvas {
    height: 150px;
  }
}
</style>

<style scoped>
.signature-head>div{display:flex;gap:8px}.signature-pad.fullscreen{position:fixed;inset:0;z-index:1000;margin:0;border:0;border-radius:0;padding:16px;background:#f4f8fc;display:flex;flex-direction:column}.signature-pad.fullscreen .signature-head{flex:0 0 auto}.signature-pad.fullscreen canvas{flex:1;height:auto;min-height:0;border:2px solid #7ca8cc}.signature-pad.fullscreen .signature-status{flex:0 0 auto}.fullscreen-actions{display:grid;grid-template-columns:1fr 2fr;gap:12px;margin-top:10px}.fullscreen-actions button{border:0;border-radius:12px;padding:13px;background:#e6edf4;color:#31495e;font-weight:700}.fullscreen-actions .done{background:#245f91;color:#fff}@media(max-width:768px){.signature-pad.fullscreen{padding:12px}.signature-pad.fullscreen canvas{height:auto}}
</style>

<style scoped>.signature-expand{display:block;width:100%;margin-top:9px;padding:11px;border:0;border-radius:10px;background:#e7f0f8;color:#245f91;font-weight:700}</style>
